<template>
  <el-table-column v-bind="$attrs">
    <template slot-scope="scope" v-if="scope.column.type !== 'selection'">
      <div :class="`item ${$attrs.type}`">
        <initial-avatar v-if="$attrs.type === 'name'" v-bind="$attrs" size="large" :avatarUrl="null" :userObject="scope.row[$attrs.type]" />
        <span v-if="$attrs.type !== 'status' && $attrs.type !== 'verified' && $attrs.type !== 'verification' && $attrs.type !== 'created_at' && $attrs.type !== 'country'">
          {{ scope.row[$attrs.type] }}
        </span>
        <span v-if="$attrs.type === 'verification'">
          {{ scope.row.is_verified ? $t('admin.organizations.table.verified') : $t('admin.organizations.table.not_verified') }}
        </span>
        <div v-if="$attrs.type === 'unredeemed_licenses'" class="">
          <b class="unredeemed_licenses">{{ getUnredeemedLicenses(scope.row) }}</b>
          <sub class="total_licenses">
            {{
              $t('admin.organizations.table.out_of_total', {
                total: getTotalLicenses(scope.row)
              })
            }}
          </sub>
        </div>
        <span v-if="$attrs.type === 'status'">
          <span :class="scope.row.status">&#9679;</span>
          {{ $t(`admin.organizations.table.${scope.row.status}`) }}
        </span>
        <span v-if="$attrs.type === 'created_at'">
          {{ formatDate(scope.row.created_at) }}
        </span>
        <span v-if="$attrs.type === 'contract_end'">
          {{ formatDate(getContractEnd(scope.row)) }}
        </span>
        <span v-if="$attrs.type === 'expected_renewal'">
          {{ formatDate(getExpectedRenewal(scope.row)) }}
        </span>
        <span v-if="$attrs.type === 'verified'">
          <verified-icon v-if="scope.row.is_verified" />
          <non-verified-icon v-if="!scope.row.is_verified" />
        </span>
        <span v-if="$attrs.type === 'country'">
          {{ getCountry(scope.row.country) }}
        </span>
      </div>
    </template>
  </el-table-column>
</template>

<script>
import VerifiedIcon from '@/assets/images/inline.verified-icon.svg'
import NonVerifiedIcon from '@/assets/images/inline.non-verified-icon.svg'
import InitialAvatar from '@/components/common/InitialAvatar'
import { slice, isNil, ifElse, always, compose, filter, propEq, propOr, pathOr } from 'ramda'
import { countries } from '@/helpers/countries'
import { parseISO, subMonths } from 'date-fns'
import subDays from 'date-fns/subDays'
import addYears from 'date-fns/addYears/index'

export default {
  props: ['value'],
  components: {
    VerifiedIcon,
    NonVerifiedIcon,
    InitialAvatar
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showOrganization() {
      this.$emit('showOrganization')
    },
    formatDate(date) {
      return ifElse(
        isNil,
        always('--'),
        compose(slice(0, 10), (date) => new Date(date).toISOString())
      )(date)
    },
    getCountry(countryCode) {
      return compose(propOr('', ['name']), pathOr([], [0]), filter(propEq('iso2', countryCode)))(countries)
    },
    getContractEnd(row) {
      if (row && row.contract && row.contract.contract_start_date) {
        let tempFrom = parseISO(row.contract.contract_start_date)

        if (tempFrom) {
          return addYears(tempFrom, 1)
        } else {
          return null
        }
      } else {
        return null
      }
    },
    getExpectedRenewal(row) {
      let end = this.getContractEnd(row)
      if (end) {
        return subMonths(end, 1)
      }
      return null
    },
    getUnredeemedLicenses(row) {
      let x = 0
      if (row && row.payment && row.payment.plan_details && row.payment.plan_details.length > 0) {
        row.payment.plan_details.forEach((element) => {
          x = x + (element.number_of_learner - element.number_of_license_used)
        })
      }
      return x
    },
    getTotalLicenses(row) {
      let x = 0
      if (row && row.payment && row.payment.plan_details && row.payment.plan_details.length > 0) {
        row.payment.plan_details.forEach((element) => {
          x = x + element.number_of_learner
        })
      }
      return x
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';

::v-deep.item {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: $dark-gray;
  &.verified {
    float: right;
    margin-right: 5px;
    z-index: 9999;
    span {
      display: flex;
    }
  }
  span {
    margin-left: 10px;
    .active {
      margin-left: 0;
      color: $blue;
      margin-right: 2px;
    }
    .inactive {
      margin-left: 0;
      margin-right: 2px;
      color: $error;
    }
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.el-table__row:hover {
  button {
    background: none;
    border: none;
    &:hover,
    &:focus {
      background: none;
    }
    &:active {
      color: $purple;
    }
  }
}
svg {
  *:not(.toFill) {
    fill: $purple;
  }
  .toFill {
    fill: $purple;
  }
}

.unredeemed_licenses {
  margin-right: 4px;
}

.total_licenses {
}

.unredeemed-licenses-wrapper {
  width: 100%;
}
</style>
